import React, { useRef, useState,useEffect } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Button,Input, Space, Table ,Modal,Popconfirm,Form, Select, message} from 'antd';
import Highlighter from 'react-highlight-words';
import { useNavigate } from 'react-router-dom';
import { getReviewerList } from 'api/journalservice';
import { getJournalList } from 'api/journalservice';
import { createReviewer } from 'api/journalservice';
import { deleteReviewer } from 'api/journalservice';
import { getReviewerDetail } from 'api/journalservice';
import { updateReviewer } from 'api/journalservice';
import '../css/ReviewerListTable.css';

const ReviewerListTable = () => {

  const [loading, setLoading] = useState(false);
  const { Option } = Select;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  const [data, setData] = useState([]);
  const [isMount, setIsMount] = useState(false);
  const [journals, setJournals] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingReviewerId, setEditingReviewerId] = useState(null);

  const fetchReviewerList = async () => {
    setLoading(true);
    try {
      const result = await getReviewerList();
      const rawData = Array.isArray(result?.data) ? result.data : [];
  
      const safeData = rawData
        .filter(item => item && typeof item === 'object')
        .map((item) => ({
          firstName: item.firstName,
          lastName: item.lastName,
          email: item.email,
          journals: item.journals,
          id: item.reviewerId,
        }));
  
      setData(safeData);
    } catch (error) {
      console.error('Error fetching reviewers:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
   
    fetchReviewerList();  

  }, []);

  
  useEffect(() => {
    if (isModalOpen) {

      getJournalList().then((response) => {
        const rawData = Array.isArray(response?.data) ? response.data : [];
        setJournals(rawData);
      });
    }
  }, [isModalOpen]);
  
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null); 
  const navigate = useNavigate();

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button type="link" size="small" onClick={() => close()}>
            Close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });


  const handleActionClick = (event,record) => {
    navigate(`./article_actions/${record.id}`);

  };
  
  const columns = [
    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',
      width: '20%',
      ...getColumnSearchProps('firstName'),

    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      key: 'Last Name',
      width: '20%',
      ...getColumnSearchProps('Last Name'),

    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: '20%',
      
    },

    {
      title: 'Journal',
      dataIndex: 'journals',
      key: 'journals',
      width: '20%',

    },
  
    {
      title: 'Action',
      key: 'action',
      width: '20%',
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => handleEdit(record)}
            className="action-btn edit-btn"
            ghost
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this reviewer?"
            onConfirm={() => handleDelete(record)}
            okText="Yes"
            cancelText="No"
          >
            <Button className="action-btn delete-btn" danger ghost>
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
    
    
  ];

  
  const handleEdit = async (record) => {
    try {
      const response = await getReviewerDetail(record.id);
      const reviewer = response?.data;
  
      if (reviewer) {
        console.log("reviewer journal:", reviewer.journals)
        form.setFieldsValue({
          firstName: reviewer.firstName,
          lastName: reviewer.lastName,
          email: reviewer.email,
          journal: reviewer.journals ,
        });
  
        setIsEditMode(true);
        setEditingReviewerId(record.id);
        setIsModalOpen(true);
      }
    } catch (err) {
      console.error('Error fetching reviewer detail:', err);
      message.error('Failed to load reviewer details');
    }
  };
  
  const handleDelete = (record) => {
    deleteReviewer(record.id).then((result) =>
    {
      message.success("Reviewer Deleted Successfully");

      // بارگذاری دوباره داده‌ها بعد از حذف
      getReviewerList().then((result) => 
      {
        const rawData = Array.isArray(result?.data) ? result.data : [];

        const safeData = rawData
          .filter(item => item && typeof item === 'object')
          .map((item) => ({
            firstName: item.firstName,
            lastName: item.lastName,
            email: item.email,
            journals: item.journals,
            id: item.reviewerId
          }));

        setData(safeData);
      });

    })
    .catch((error) => {
      console.error("Error Deleting Reviewer!", error);
      message.error("Error Deleting Reviewer!");
    });
  };

 
  const handleFinish = async (values) => {
    try {
      let response;
  
      if (isEditMode && editingReviewerId) {
        response = await updateReviewer(editingReviewerId, values);
  
        if (response?.result?.result === true) {
          message.success('Reviewer updated successfully');
        } else {
          message.error('Failed to update reviewer');
          return;
        }
  
      } else {
        response = await createReviewer(values);
  
        if (response?.result?.result === true) {
          message.success('Reviewer added successfully');
        } else {
          message.error('Failed to add reviewer');
          return;
        }
      }
  
      // بعد از موفقیت:
      setIsModalOpen(false);
      form.resetFields();
      setIsEditMode(false);
      setEditingReviewerId(null);
      fetchReviewerList(); // تابعی که معرفی کردیم
  
    } catch (error) {
      console.error('Error submitting reviewer:', error);
      message.error('There was an error submitting the reviewer');
    }
  };
  
  return (
    
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <Button className="add-new-btn" onClick={showModal}>
          + Add New Reviewer
        </Button>
      </div>
      <Modal
        title={isEditMode ? "Edit Reviewer" : "Add New Reviewer"}
        open={isModalOpen}
        onCancel={() => {
        form.resetFields();
        setIsModalOpen(false);
        setIsEditMode(false);
        setEditingReviewerId(null);
        }}
        footer={null}
        centered
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
        >
          <Form.Item
            label="First Name"
            name="firstName"
            rules={[{ required: true, message: 'Please enter first name' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Last Name"
            name="lastName"
            rules={[{ required: true, message: 'Please enter last name' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, type: 'email', message: 'Enter a valid email' }]}
          >
            <Input disabled={isEditMode} />
          </Form.Item>

          <Form.Item
            label="Journal"
            name="journal"
            rules={[{ required: true, message: 'Please select at least one journal' }]}
            >
            <Select placeholder="Select a journal" mode="multiple"  disabled={isEditMode}>
              {journals.map((journal) => (
                <Option key={journal.id} value={journal.id}>
                  {journal.title}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={
              isEditMode
                ? [] // در حالت ویرایش الزامی نیست
                : [{ required: true, message: 'Please enter password' }]
            }
          >
            <Input.Password placeholder={isEditMode ? "Leave empty to keep current password" : ""} />
          </Form.Item>
         

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              {isEditMode ? 'Update' : 'Submit'}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
   
      <Table 
        columns={columns} 
        dataSource={data} 
        loading={loading}
        rowKey="id" 
        onRow={(record) => ({
          style: { cursor: 'pointer' }, 
          
        })} 
        rowClassName={() => 'custom-row-hover'} 

      />

    </>
  );
 

};

export default ReviewerListTable;
